import { MARQUEE } from "../lib/routes";
import { LogoMark } from "./Logo";

export const Marquee = () => {
  const words = [...MARQUEE, ...MARQUEE];
  return (
    <div className="marquee-wrap overflow-hidden border-y border-[var(--line)] py-8 md:py-10 bg-[var(--paper)]" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex w-max items-center gap-10 md:gap-14 whitespace-nowrap">
        {words.map((w, i) => (
          <span key={i} className="flex items-center gap-10 md:gap-14">
            <span className={`font-display text-5xl md:text-7xl font-light tracking-tight ${i % 3 === 1 ? "text-outline" : i % 3 === 2 ? "text-[var(--teal-ink)] italic" : "text-[var(--ink)]"}`}>{w}</span>
            <LogoMark className="h-5 w-auto opacity-70" />
          </span>
        ))}
      </div>
    </div>
  );
};
